<template>
  <sticky-header-layout>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="Name"
      >
        <template slot-scope="{ row }">
          {{ row }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="65"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import { getTrendingBrandList } from '../../api/trendings'

export default {
  name: 'TrendingBrandList',
  mixins: [useTablePaging],
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getTrendingBrandList()
        const brands = response.data
        if (Array.isArray(brands)) {
          this.list = brands
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleUpdate(row) {
      this.$router.push({ path: `/trending/brand-edit/${row}` })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

